document.addEventListener('DOMContentLoaded', function () { 
   /** show social media */
  document.querySelectorAll(".footer-block__brand-info .footer__list-social .list-social__link").forEach(function(social) { 
    social.classList.remove("link");
    social.querySelector("span").classList.remove("visually-hidden");
  });
  
  /** testimonials read more */
  const readMoreBtns = document.querySelectorAll('.truncated-text--wrapper .read-more'); 
  if(readMoreBtns) { 
    readMoreBtns.forEach(elem => {
      elem.addEventListener('click', function () { 
        const parentEle = this.closest('.truncated-text--wrapper');
        const fullText = parentEle.querySelector('.full-text'); 
        const truncatedText = parentEle.querySelector('.truncated-text');
        if(fullText.classList.contains('visually-hidden')) { 
          fullText.classList.remove('visually-hidden');
          truncatedText.classList.add('visually-hidden');
          this.textContent = 'Read Less';
        } else { 
            fullText.classList.add('visually-hidden');
            truncatedText.classList.remove('visually-hidden');
            this.textContent = 'Read More';
        }
      })
    });
  }

  
});